<template>
  <v-card>
    <v-card-title>
      <div class="flex-grow-1">Quality Gaps</div>
      <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :loading="loading" :headers="headers" :items="patient_data" :search="search">
      <template v-slot:no-data> No Quality Gaps </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios';

export default {
  name: 'QualityGaps',
  props: ['patient', 'insurance', 'recordLimit'],

  data() {
    return {
      search: '',
      loading: false,
      headers: [],
      patient_data: [],
    };
  },
  mounted() {
    this.getClaims();
  },
  methods: {
    async getClaims() {
      this.loading = true;
      this.headers = [];

      this.getHeaders();

      // *** IN CASE WE NEED TO USE THESE LATER
      const startDate = new Date(new Date().getFullYear(), 0, 1).toISOString().substring(0, 7);
      const endDate = new Date(new Date().getFullYear(), 11, 31).toISOString().substring(0, 7);

      await axios
        .get(
          `/api/quality/qualitygaps/orgs=/groups=/providers=/locs=/${this.patient}/${this.insurance}/${startDate}/${endDate}${this.recordLimit}`
        )
        .then((response) => {
          console.log(response);
          this.patient_data = response.data;
          this.loading = false;
        });
    },
    getHeaders() {
      this.headers = [
        { text: 'Patient Name', value: 'PATIENT_NAME' },
        { text: 'DOB', value: 'DOB' },
        { text: 'Patient ID', value: 'PATIENT_ID' },
        { text: 'RPT_PE', value: 'RPT_PE' },
        { text: 'Open Opportunities', value: 'OPEN_CONDITIONS' },
        { text: 'ADH_ACE', value: 'ADH_ACE' },
        { text: 'ADH_DIAB', value: 'ADH_DIAB' },
        { text: 'ADH_STATIN', value: 'ADH_STATIN' },
        { text: 'ART', value: 'ART' },
        { text: 'Breast Cancer Screening (BCS)', value: 'BCS' },
        { text: 'Controlling High Blood Pressure (CBP)', value: 'CBP' },
        { text: 'CDC2_EYE', value: 'CDC2_EYE' },
        { text: 'CDC2_HBAPOOR', value: 'CDC2_HBAPOOR' },
        { text: 'CDC2_NPH', value: 'CDC2_NPH' },
        { text: 'COA_FSA', value: 'COA_FSA' },
        { text: 'COA_MDR', value: 'COA_MDR' },
        { text: 'COA_PNS', value: 'COA_PNS' },
        { text: 'Colorectal Cancer Screening (COL)', value: 'COL' },
        { text: 'MRP', value: 'MRP' },
        { text: 'OMW', value: 'OMW' },
        { text: 'Plan All-Cause Readmissions (PCR)', value: 'PCR' },
        { text: 'SPC_STATIN', value: 'SPC_STATIN' },
        { text: 'SUPD', value: 'SUPD' },
      ];
    },
  },
};
</script>
